var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 1 5 0 0 5l5 5 .8-1-4-4 4-4Z",
    fill: "currentColor"
  })));
};

export default SvgArrow;